export default __webpack_public_path__ + "static/media/paragraphe.3c895c13.svg";